import { environment } from '../../../environments/environment';

type HubEnv = {
    hubAppUrl?: string;
};

const HUB_PLAN_UPGRADE_PRODUCT = 'Ratoeira Ads';
const SUPPORT_UPGRADE_URL = 'https://links.ratoeirads.com/suporte';

type UpgradeEnv = HubEnv & {
    upgradeButtonUsesSupportLink?: boolean;
};

/** Base do hub-app-front, sem barra final. */
export function resolveHubAppUrl(env: HubEnv = environment): string {
    return env.hubAppUrl?.trim().replace(/\/$/, '') ?? '';
}

/** login sempre realizado pelo novo hub */
export function isHubRedirectActive(env: HubEnv = environment): boolean {
    return Boolean(resolveHubAppUrl(env));
}

export function buildHubLoginUrlWithReturn(returnUrl: string, env: HubEnv = environment): string {
    const params = new URLSearchParams();
    params.set('returnUrl', returnUrl);
    return `${resolveHubAppUrl(env)}/login?${params.toString()}`;
}

/** Preferências da conta no Hub (idioma, fuso e formato de data). */
export function buildHubPreferencesUrl(env: HubEnv = environment): string {
    return buildHubPath('/preferences', env);
}

/** Alteração de senha no Hub. */
export function buildHubChangePasswordUrl(env: HubEnv = environment): string {
    return buildHubPath('/change-password', env);
}

/** Página de upgrade do plano no Hub. */
export function buildHubPlanUpgradeUrl(subscriptionId: string, env: HubEnv = environment): string {
    const params = new URLSearchParams();
    params.set('id', subscriptionId);
    params.set('product', HUB_PLAN_UPGRADE_PRODUCT);
    return `${resolveHubAppUrl(env)}/plan/upgrade/?${params.toString()}`;
}

/** Mesmo destino do botão de upgrade do dialog de bloqueio. */
export function resolvePlanUpgradeUrl(
    subscriptionId: string | null | undefined,
    env: UpgradeEnv = environment,
): string {
    if (env.upgradeButtonUsesSupportLink || !subscriptionId) {
        return SUPPORT_UPGRADE_URL;
    }

    return buildHubPlanUpgradeUrl(subscriptionId, env);
}

function buildHubPath(path: string, env: HubEnv): string {
    const base = resolveHubAppUrl(env);
    if (!base) {
        return '';
    }
    return `${base}${path}`;
}

/** Home do Hub (botão voltar e destino após logout voluntário). */
export function resolveHubHomeUrl(env: HubEnv = environment): string {
    return resolveHubAppUrl(env);
}

/** Hub após logout voluntário no produto — sinaliza para limpar deep link pendente. */
export function resolveHubUrlAfterProductLogout(env: HubEnv = environment): string {
    const base = resolveHubHomeUrl(env);
    if (!base) return '';
    try {
        const url = new URL(base);
        url.searchParams.set('fromProductLogout', '1');
        return url.toString();
    } catch {
        return `${base}?fromProductLogout=1`;
    }
}
